<template>
  <kd-layout-fixed-bottom-button class="campus-academy-manage-container">
    <div class="aca-list">
      <div @click="() => {}" v-for="item in list" :key="item.id" class="clazz-describe-base">
        <div class="left">
          <div class="avatar" v-if="item.name">{{ item.name.slice(0, 1) }}</div>
          <div class="avatar" v-else>
            <!-- <img src="./assets/default_major.png" /> -->
          </div>
          <div class="describe">
            <div class="top">
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="bottom">
              <slot></slot>
            </div>
          </div>
        </div>
        <div v-if="options.length" class="options" @click="handleOptions(item)">
          <img src="./assets/icon_more_label.png" />
        </div>
        <!-- <div class="teach" :class="item.isMine ? 'has-teach' : 'not-teach'" v-if="show" @click.stop="teachClazz">
          {{ item.isMine ? '√ 已执教' : showText }}
        </div> -->
      </div>
    </div>
    <CreateClassPopup
      v-if="isCreateClassPopupVisible"
      :name="curItem ? curItem.name : ''"
      :visible.sync="isCreateClassPopupVisible"
      @submit="handleNameSubmit"
    />
    <TipPopup
      :visible.sync="isTipVisible"
      :title="tip.title"
      :content="tip.content"
      :cancelText="tip.cancelText"
      :okText="tip.okText"
      @submit="handleDelete"
      @cancel="isTipVisible = false"
    />
    <MoreSelectPopup
      v-if="options.length"
      :visible.sync="isOptionsVisible"
      :options="options"
      @edit="handleEditClick"
      @delete="handleDeleteClick"
    />
    <template #footer>
      <div class="btns">
        <kd-button class="create-course" @click="handleCreateClass"> 创建学院 </kd-button>
      </div>
    </template>
  </kd-layout-fixed-bottom-button>
</template>

<script lang="ts">
import { BasePage, Component, PopupPosterAsync, SuccessTipPopup, TipPopup } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdButton, KdSelect, KdNoData } from 'kuaidong-ui'
import { loginStore, teacherStore } from 'kuaidong-store'
import { AppUtil } from 'kuaidong-lib'
import CreateClassPopup from './components/CreateClassPopup.vue'
import MoreSelectPopup from './components/MoreSelectPopup.vue'
import { addAcademy, deleteAcademy, getList } from './api'
import { IAcademyItem } from './model'
@Component({
  components: {
    KdLayoutFixedBottomButton,
    KdButton,
    KdSelect,
    KdNoData,
    PopupPosterAsync,
    SuccessTipPopup,
    TipPopup,
    CreateClassPopup,
    MoreSelectPopup,
  },
})
export default class AcademyManageHome extends BasePage {
  isUnderApp = false
  hasWork = false
  isCreateClassPopupVisible = false
  list: any[] = []

  isOptionsVisible = false
  options: string[] = []
  curItem: IAcademyItem | null = null
  tip = {
    title: '是否解散该学院？',
    content: '解散后，班级同时被解散，所有学生、老师将会移出班级，所有数据将丢失，请谨慎操作！',
    cancelText: '取消',
    okText: '解散学院',
  }
  isTipVisible = false
  async mounted() {
    if (loginStore.userTeacherId === null) {
      await loginStore.loadUserTeacherId()
    }
    if (teacherStore.teacher == null) {
      await teacherStore.loadTeacher()
    }
    if (
      teacherStore.teacher?.role == 'school_manager' ||
      teacherStore.teacher?.role == 'pe_manager' ||
      teacherStore.isAdmin
    ) {
      this.options = ['edit', 'delete']
    } else if (teacherStore.teacher?.role == 'others') {
      this.options = []
    } else {
      this.options = ['edit']
    }
    try {
      await this.init()
      this.isUnderApp = await AppUtil.isUnderApp()
    } catch (error) {
      console.log(error)
    }
  }
  async init() {
    this.list = await getList()
    this.curItem = null
  }
  handleOptions(item: IAcademyItem) {
    if (this.options.length) {
      this.isOptionsVisible = true
      this.curItem = item
    }
  }
  async handleDelete() {
    if (this.curItem == null) return
    try {
      await deleteAcademy(this.curItem.id)
      this.isTipVisible = false
      this.toast('删除成功')
      await this.init()
    } catch (error) {
      this.toast(error)
    }
  }
  async handleDeleteClick() {
    if (this.curItem == null) return
    this.isOptionsVisible = false
    this.isTipVisible = true
  }
  async handleNameSubmit(name: string) {
    if (this.list.map((i) => i.name).includes(name)) {
      this.toast('学院名称已存在')
      return
    }
    try {
      await addAcademy(name, this.curItem?.id)
      this.toast('创建成功')
      this.isCreateClassPopupVisible = false
      this.init()
    } catch (e) {
      this.toast(e.text || '创建失败')
      console.log(e)
    }
  }
  handleEditClick() {
    this.isOptionsVisible = false
    this.isCreateClassPopupVisible = true
  }

  forceAuth() {
    this._forceAuth()
  }
  handleCreateClass() {
    this.isCreateClassPopupVisible = true
  }
}
</script>

<style lang="less">
.campus-academy-manage-container {
  height: 100%;
  box-sizing: border-box;
  .kd-layout-fixed-bottom__main {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    > .aca-list {
      padding: 20px;
      > .clazz-describe-base {
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 8px 24px rgba(196, 203, 214, 0.2);
        border-radius: 12px;
        height: 88px;
        padding: 20px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        > .left {
          display: flex;
          align-items: center;
          > .avatar {
            flex: none;
            margin-right: 12px;
            text-align: center;
            background: #3366ff;
            border-radius: 14.4px;
            width: 48px;
            height: 48px;
            font-weight: 600;
            font-size: 18px;
            line-height: 48px;

            color: #ffffff;
            img {
              width: 24px;
              vertical-align: text-top;
            }
          }
          > .describe {
            > .top {
              display: flex;
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              color: #4d4d4d;
              text-align: left;
              > .year {
                margin-right: 5px;
              }
            }
            > .bottom {
              display: flex;
              margin-top: 5px;
              > div {
                background: #f7f8fa;
                border: 1px solid #81848f;
                border-radius: 4px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 1px 5px;
                height: 20px;
                margin-right: 5px;
                color: #81848f;
                line-height: 20px;
              }
              > .count {
                flex: none;
              }

              > .major {
                display: block;
                flex: none;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 120px;
              }
            }
          }
        }
        > .options {
          > img {
            width: 24px;
          }
        }
        // > .teach {
        //   flex: none;
        //   border-radius: 23px;
        //   padding: 6px 8px;
        //   font-size: 12px;
        //   line-height: 16px;
        //   border: 1px solid #3366ff;
        //   color: #3366ff;
        //   &.has-teach {
        //     border: 1px solid #e1e4ed;
        //     color: #b8b8b8;
        //   }
        // }
      }
    }

    > .kd-popup.kd-comp-tip-show-popup {
      > .kd-popup__main {
        > .kd-popup__content {
          > .main {
            > .buttons {
              > .ok-button {
                background: #eb3c0b;
              }
            }
          }
        }
      }
    }
  }

  > .kd-layout-fixed-bottom__footer {
    padding-left: 20px;
    padding-right: 20px;

    > .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > .kd-button.create-course {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        background: #3366ff;
        color: #fff;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
      }
    }
  }
}
</style>
